/**
 * Preise und Zahlungsperioden der SAIA-Lizenzen für Wizard und Zahlungs-Modal.
 * Die Beträge müssen zu den Stripe-Preisen passen (stripe-products.config.ts in der API).
 */

export type BillingPeriod = 'monthly' | 'quarterly' | 'yearly';

/** Monatlicher Basispreis pro Seat (muss zu den Stripe-Preisen passen). */
export const MONTHLY_BASE: Record<string, number> = {
  saia_recruiting: 139.9,
  saia_sales: 139.9,
  saia_bundle: 249.9,
};

/** Rabatt nach Zahlungsperiode: Quartal -10 %, Jahr -20 %. */
export const PERIOD_META: Array<{
  key: BillingPeriod;
  de: string;
  en: string;
  months: number;
  discount: number;
  badge?: string;
}> = [
  { key: 'monthly', de: 'Monatlich', en: 'Monthly', months: 1, discount: 0 },
  { key: 'quarterly', de: 'Quartalsweise', en: 'Quarterly', months: 3, discount: 0.1, badge: '-10 %' },
  { key: 'yearly', de: 'Jährlich', en: 'Yearly', months: 12, discount: 0.2, badge: '-20 %' },
];

export const euro = (n: number) =>
  n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

/** Monatlicher Grundpreis einer Auswahl, z. B. [{ product: 'saia_bundle', quantity: 2 }]. */
export const monthlyTotal = (products: Array<{ product: string; quantity: number }>) =>
  products.reduce((sum, p) => sum + (MONTHLY_BASE[p.product] ?? 0) * p.quantity, 0);
